export interface ReportModel {
    reportID?: number,
    reportLabel?: string,
    systemType?: SystemType,
    promptForMap?: boolean,
    reportParameters?: Array<ReportParameter>
}

export interface ExportModel {
    exportID?: number,
    exportLabel?: string,
    viewName?: string,
    systemType?: SystemType,
    exportParameters?: Array<ReportParameter>
}

export interface ReportParameter {
    name: string,
    values: Array<string>
}

export enum SystemType {
    OfficerMap_RecordList_Maint_Single,
    OfficerMap_RecordList_Maint_Multi,
    OfficerMap_RecordList_Infra_Single,
    OfficerMap_RecordList_Infra_Multi,
    OfficerMap_RecordList_Route_Single,
    OfficerMap_RecordList_Route_Multi,
    OfficerMap_RecordList_Land_Single,
    OfficerMap_RecordList_Land_Multi,
    OfficerMap_RecordList_Path_Single,
    OfficerMap_RecordList_Path_Multi,
    AnnotationSimpleMap,
    Contact_RecordList_Single,
    Contact_RecordList_Multi,
    MyTasks_Task_Single,
    MyTasks_Task_Multi,
    TaskManagement_Task_Single,
    TaskManagement_Task_Multi,
    LegalEvents_Single,
    LegalEvents_Multi
}

